import { useContext, useEffect, useState } from 'react';
import ReactPlayer from 'react-player'
import './../../style/videoFlipCard.css';

function VideoFlipCard({videoPath, title, answer}){
    const [flip, setFlip] = useState(false)


    const toggleFlip = () => {
        setFlip(oldFlip => !oldFlip)
    }

    return (
        <div className='container example-container'>

            <div className='card card-video'>
                <div className='card-body'>
                    <div className='video-flip-card'>
                        <div className={"flip-card-inner " + (flip === true ? "flip" : "")}>
                            <div className='flip-card-front'> 
                                <h5 className='card-title'>{title}</h5>
                                <ReactPlayer url={videoPath} width={400} height={300} controls={true} />
                                <button className="btn btn-primary mt-3" onClick={toggleFlip} >Lösung ansehen</button>
                            </div>
                            <div className='flip-card-back '> 
                                <div className='videoResult result-txt'>
                                    <div>
                                        <h3>Die Antwort lautet:</h3>
                                        <h2>{answer}</h2>
                                    </div>
                                    <button className="btn btn-primary " onClick={toggleFlip}>Zurück</button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VideoFlipCard